import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/refresh.svg'


const _withScopeId = n => (_pushScopeId("data-v-a9cbc6f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen screen-overlay" }
const _hoisted_2 = { class: "action-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: "Reselect player"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_categories_list = _resolveComponent("categories-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_categories_list),
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.player.name) + " is up! ", 1),
      _createElementVNode("button", {
        class: "refresh",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
      }, _hoisted_4)
    ]),
    _createElementVNode("button", {
      class: "btn-link action-right",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.endGame && _ctx.endGame(...args)))
    }, "End Game")
  ]))
}